import {Divider, Grid, IconButton, Stack, Typography} from '@mui/material';
import {ArrowBack} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Add, Delete, GroupAction} from '@icons/index';
import React from 'react';
import TableCard from '@components/cards/table/Table.card';
import {Colors} from '@constants/colors.constants';
import InfosCard from '@components/cards/infos/Infos.card';

const PriceCatalogDetailsView = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const items = [
    {
      id: 1,
      title: 'Glass',
      subtitle: '43 chf',
      // type: WasteTypeEnum.GLASS,
      icons: [{
        id: 2,
        icon: <GroupAction/>,
        onClick: () => undefined
      }, {
        id: 3,
        icon: <Delete/>,
        onClick: () => undefined
      },],
      subCategories: [{
        id: 4,
        title: 'Verre Pyrex',
        unit: 'kg/m3',
        value: 300,
      },
        {
          id: 5,
          title: 'Verre à estamper',
          unit: 'm3',
          value: 16,
        }]
    },
    {
      id: 6,
      title: 'Steel',
      // type: WasteTypeEnum.STEEL,
      icons: [{
        id: 7,
        icon: <GroupAction/>,
        onClick: () => undefined
      }, {
        id: 8,
        icon: <Delete/>,
        onClick: () => undefined
      },],
      subCategories: [{
        id: 9,
        title: 'Acier en plastique',
        unit: 'kg',
        value: 300,
      },
        {
          id: 10,
          title: 'Acier trempé',
          unit: 't',
          value: 3,
        }]
    }
  ];

  return (
    <Grid item>
      <Grid container alignItems="center" style={{paddingTop: 15}}>
        <IconButton onClick={() => navigate('../price-catalog', {replace: true})}> <ArrowBack/> </IconButton>
        <Typography fontWeight="bolder" fontSize={18}> {t('settings.priceCatalog.edit.title')} </Typography>
      </Grid>
      <Grid container style={{
        paddingBottom: 7,
        paddingTop: 7
      }}>
        <Typography> Groupe 1 </Typography>
        <Typography style={{color: Colors.textWithOpacity}}> (10 organisations) </Typography>
      </Grid>
      <Divider style={{
        width: '12%',
        borderBottomWidth: 5,
        borderColor: Colors.primary
      }}/>
      {items.map((item) => <Stack style={{paddingRight: 30}}>
          <TableCard
            key={item.id}
            // icons={item.icons}
            // type={item.type}
            title={item.title}
            subTitle={item.subtitle}
            noArrow
          >
            <>
              <Grid container justifyContent="space-between" style={{padding: 20}}>
                <Typography fontWeight="bolder"> {t('settings.waste.subtitle')} </Typography>
                <IconButton
                  style={{
                    backgroundColor: Colors.primary,
                    width: 35,
                    height: 35,
                    borderRadius: 4
                  }}
                  color="primary"
                  onClick={() => navigate(`:${item.id}/add`, {replace: true})}>
                  <Add/>
                </IconButton>
              </Grid>
              <Grid container direction={'row'}>
                {item.subCategories.map((subCat) => <InfosCard
                  key={subCat.id}
                  title={subCat.title}
                  value={subCat.value}
                  // icons={[{
                  //   id: 1,
                  //   icon: <GroupAction/>,
                  //   onClick: () => handleEdit(subCat.id)
                  // },
                  //   {
                  //     id: 2,
                  //     icon: <Delete/>,
                  //     onClick: () => handleEdit(subCat.id)
                  //   }]}
                  unit={subCat.unit}/>)}
              </Grid>
            </>
          </TableCard>
        </Stack>
      )}
    </Grid>
  );
};

export default PriceCatalogDetailsView;
